export default __webpack_public_path__ + "static/media/services.6cef040d.jpg";